if (!customElements.get('kvs-article-editorial')) {
  customElements.define('kvs-article-editorial', class extends HTMLElement {
    constructor() {
      super();
      this.copyTimers = new Set();
      this.onScroll = () => {
        if (!this.progressFrame) this.progressFrame = requestAnimationFrame(() => this.updateProgress());
      };
      this.onClick = (event) => {
        const button = event.target.closest('.article-editorial__copy-btn');
        if (button && this.contains(button) && !button.disabled && !button.classList.contains('is-copied')) this.copyLink(button);
      };
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.connectionId = (this.connectionId || 0) + 1;
      this.progressBar = this.querySelector('.article-editorial__progress-bar');
      this.content = this.querySelector('.article-editorial__content');
      this.querySelectorAll('.article-editorial__copy-btn').forEach(button => { button.hidden = false; });
      this.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.updateProgress();
    }

    disconnectedCallback() {
      this.initialized = false;
      this.connectionId++;
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.progressFrame) cancelAnimationFrame(this.progressFrame);
      this.progressFrame = null;
      this.copyTimers.forEach(timer => clearTimeout(timer));
      this.copyTimers.clear();
      this.querySelectorAll('.article-editorial__copy-btn').forEach(button => {
        if (button.dataset.originalMarkup) {
          button.innerHTML = button.dataset.originalMarkup;
          delete button.dataset.originalMarkup;
        }
        button.disabled = false;
        button.classList.remove('is-copied');
        button.setAttribute('aria-label', button.dataset.copyLabel);
      });
    }

    updateProgress() {
      this.progressFrame = null;
      if (!this.isConnected || !this.progressBar || !this.content) return;
      const rect = this.content.getBoundingClientRect();
      const total = rect.height - window.innerHeight;
      const progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
      this.progressBar.style.transform = `scaleX(${progress})`;
    }

    async copyLink(button) {
      const connectionId = this.connectionId;
      const group = button.closest('[data-article-share]');
      const status = group && group.querySelector('.article-editorial__share-status');
      const original = button.innerHTML;
      let success = false;
      button.disabled = true;
      if (status) status.textContent = '';
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(button.dataset.shareUrl);
          success = true;
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = button.dataset.shareUrl;
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          try { success = document.execCommand('copy'); }
          finally {
            textarea.remove();
            button.disabled = false;
            button.focus();
          }
        }
      } catch (error) {
        success = false;
      }
      if (!this.isConnected || connectionId !== this.connectionId) return;
      if (!success) {
        if (status) status.textContent = button.dataset.errorLabel;
        button.disabled = false;
        return;
      }
      button.dataset.originalMarkup = original;
      button.classList.add('is-copied');
      button.setAttribute('aria-label', button.dataset.copiedLabel);
      if (button.textContent.trim()) button.textContent = button.dataset.copiedLabel;
      if (status) status.textContent = button.dataset.copiedLabel;
      const timer = setTimeout(() => {
        this.copyTimers.delete(timer);
        button.classList.remove('is-copied');
        button.innerHTML = original;
        delete button.dataset.originalMarkup;
        button.setAttribute('aria-label', button.dataset.copyLabel);
        button.disabled = false;
      }, 1800);
      this.copyTimers.add(timer);
    }
  });
}
